// Adds accessibility
jQuery(document).ready(function ($) {
    //Keyboard navigation
    $('.bocss-radio__label').keypress(function (e) {
        if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
            $(this).click();
            return false;
        }
    });
    //When a radio button is selected
    $('.bocss-radio__group span input:radio').change(function () {
        //set this one to true
        $(this).parent().find('label').attr('aria-selected', true);

        //get all inputs that aren't selected, and set to false
        var $inputs = $(this).parent().parent().find('input').not(this);
        $inputs.each(function () {
            $(this).parent().find('label').attr('aria-selected', false);
        });
    });
});
